module.exports = __webpack_public_path__ + "static/media/Autumn Campus-20181102060-JO.05efaf07.jpg";